<template>
    <div class="pl-0" v-show="onDisplay">
        <p class="mt-0 mb-0" :id="timezoneName">
            <b>{{ timezoneName }}</b
            >: {{ currentTime }}
        </p>
    </div>
</template>
<script>
import { helper } from "@components/mixins/helper";
import dayjs from "dayjs";

export default {
    components: {},
    mixins: [helper],
    props: {
        name: "",
        timeZone: 0,
        DST: false,
    },
    data() {
        return {
            timezoneName: "",
            currentTime: null,
            interval: null,
            onDisplay: true,
        };
    },
    methods: {
        changeTimeStringByTimeZone(tz) {
            const localtime = new Date();
            this.currentTime = dayjs(localtime)
                .tz(tz)
                .format("DD/MM/YYYY, HH:mm:ss A");
        },
    },
    mounted() {
        this.timezoneName = this.name;
        this.interval = setInterval(() => {
            if (this.timezoneName === "MT") {
                this.currentTime = this.getMT4Time();
            }
            if (this.timezoneName === "SYD") {
                this.changeTimeStringByTimeZone("Australia/Sydney");
            }

            if (this.timezoneName === "BJ") {
                this.changeTimeStringByTimeZone("Asia/Shanghai");
            }
            if (this.timezoneName === "NY") {
                this.changeTimeStringByTimeZone("America/New_York");
            }
            if (this.timezoneName === "LDN") {
                this.changeTimeStringByTimeZone("Europe/London");
            }
            if (this.timezoneName === "JKT") {
                this.changeTimeStringByTimeZone("Asia/Jakarta");
            }
            // if (document.body.clientWidth < 1550) {
            //     this.currentTime = this.currentTime.split(", ")[1];
            // }
            // if (document.body.clientWidth < 550) {
            //     this.onDisplay = false || this.timezoneName === "MT4";
            // } else {
            //     this.onDisplay = true;
            // }
        }, 1000);
    },
    destroyed() {
        clearInterval(this.interval);
    },
};
</script>
